import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface UpdateLeadRequest {
  tags?: string[];
}

const patchLead = async (
  authToken: string,
  leadId: string,
  body: UpdateLeadRequest
): Promise<{ lead: Lead }> => {
  const { data } = await axiosConfig.patch(`/leads/${leadId}`, body, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default patchLead;
